import { nanoid } from 'nanoid';
export function getValue(size) {
    return nanoid(size);
}
